import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[stopPropagation]',
})
export class ClickStopPropagationDirective {
  @HostListener('click', ['$event'])
  stopClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
